import React from "react";
import "./Page2.css";
//-----------------------------------------
import { NavLink } from "react-router-dom";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
//-----------------------------------------
import pagePhoto2 from "../images/pagePhoto2.png";
//-----------------------------------------

function Page2() {
  return (
    <div className="page2_container">
      <div className="page2_bangla">
        প্রতিষ্ঠানটির ব্যাবসায়িক ক্ষেত্র অনুযায়ী শ্রেণীবদ্ধ বিভিন্ন Product
        Category র মধ্যে আপনার প্রয়োজনীয় Product টির বিভাগে Click করে সেই বিভাগে
        যেতে হবে।
      </div>
      <div className="page2_english">
        In this page products are categorized depending on the type of business
        this particular Web-App is made for. As per the requirement of the
        Customer a category is to be clicked and opened.
      </div>
      <div className="page2_photo_div">
        <img className="page2_photo" src={pagePhoto2} alt="PagePhoto2 Logo" />
      </div>
      {/*--------------go to page-3 (next page) starts-------------*/}
      <NavLink to="/page3" className="goto_next_page" exact>
        <span className="forwardIcon_text">Next</span>
        <ArrowForwardIcon className="next_page_icon" />
      </NavLink>
      {/*--------------go to page-3 (next page) ends-------------*/}
    </div>
  );
}

export default Page2;
